<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <h6>
                                                {{
                                                    $t(
                                                        "edit_client_description"
                                                    )
                                                }}
                                            </h6>
                                            <br />
                                            <SelectAsync
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName:
                                                            'client_model_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general
                                                        .client_model_id.$model
                                                "
                                                :label="$t('client')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('client_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                                optionsValue="uuid"
                                                optionsLabel="name"
                                                endpoint="clients.api"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName: 'sale_price',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.sale_price
                                                        .$model
                                                "
                                                :label="$t('sale_price')"
                                                :placeholder="
                                                    $t('enter_the_sale_price')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CTextarea
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName:
                                                            'description',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.description
                                                        .$model
                                                "
                                                :label="$t('description')"
                                                :placeholder="
                                                    $t('enter_the_description')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'description_is_required'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectCountry
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName: 'country_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.country_id
                                                        .$model
                                                "
                                                :label="$t('country')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('country_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'general',
                                                        fieldName: 'debug_mode',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.debug_mode
                                                        .$model
                                                "
                                                :options="[
                                                    {
                                                        value: 1,
                                                        label: $t('yes'),
                                                    },
                                                    {
                                                        value: 0,
                                                        label: $t('no'),
                                                    },
                                                ]"
                                                :label="$t('debug_mode')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                        </CCard>
                                    </CTab>

                                    <!-- Customers tabs -->
                                    <CTab
                                        :title="$t('databases')"
                                        :disabled="view_type != 'edit'"
                                    >
                                        <CCard bodyWrapper>
                                            <SelectAsync
                                                :label="$t('find_a_database')"
                                                :placeholder="
                                                    $t('search_database')
                                                "
                                                @change="onChangeSelectDBs"
                                                :optionsValue="'uuid'"
                                                :optionsLabel="'name'"
                                                :endpoint="'db'"
                                            />
                                            <!-- Table clientes -->
                                            <CDataTable
                                                :addTableClasses="['table--sm']"
                                                :items="tables.databases.items"
                                                :fields="
                                                    traslateLabels(
                                                        tables.databases.fields
                                                    )
                                                "
                                                :noItemsView="{
                                                    noItems: $t('no_databases'),
                                                }"
                                                hover
                                                striped
                                            >
                                                <template #name="{ item }">
                                                    <td>
                                                        <div v-if="item.name">
                                                            {{ item.name }}
                                                        </div>
                                                        <div v-else>-</div>
                                                    </td>
                                                </template>
                                                <template #options="{ item }">
                                                    <td
                                                        class="py-2 text-center"
                                                    >
                                                        <CButton
                                                            color="danger"
                                                            variant="outline"
                                                            class="ml-1"
                                                            square
                                                            size="sm"
                                                            @click="
                                                                deleteDatabase(
                                                                    item
                                                                )
                                                            "
                                                        >
                                                            <CIcon
                                                                class="icon"
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilTrash
                                                                "
                                                            />
                                                        </CButton>
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCard>
                                    </CTab>

                                    <CTab :title="$t('capping')">
                                        <CCard bodyWrapper>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('capping_interval')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_allows_you_to_set_a_maximum_OK_limit_in_the_configured_interval'
                                                        )
                                                    "
                                                />

                                                <CSelect
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping_interval',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_interval
                                                            .$model
                                                    "
                                                    :options="[
                                                        {
                                                            value: 'N',
                                                            label: $t(
                                                                'Without Capping'
                                                            ),
                                                        },
                                                        {
                                                            value: 'D',
                                                            label: $t('day'),
                                                        },
                                                        {
                                                            value: 'W',
                                                            label: $t('week'),
                                                        },
                                                        {
                                                            value: 'M',
                                                            label: $t('month'),
                                                        },
                                                    ]"
                                                    :label="
                                                        $t('capping_interval')
                                                    "
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'capping_interval_is_required'
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general.capping
                                                            .$model
                                                    "
                                                    :label="$t('capping')"
                                                    :placeholder="
                                                        $t('enter_the_capping')
                                                    "
                                                    :invalidFeedback="
                                                        $t('requires_a_number')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                                <hr />
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping_total',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_total
                                                            .$model
                                                    "
                                                    type="number"
                                                    :label="$t('capping_total')"
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_capping_total'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t('requires_a_number')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />

                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping_daily',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_daily
                                                            .$model
                                                    "
                                                    type="number"
                                                    :label="$t('capping_daily')"
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_capping_daily'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t('requires_a_number')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />

                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping_weekly',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_weekly
                                                            .$model
                                                    "
                                                    type="number"
                                                    :label="
                                                        $t('capping_weekly')
                                                    "
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_capping_weekly'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t('requires_a_number')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'capping_monthly',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_monthly
                                                            .$model
                                                    "
                                                    type="number"
                                                    :label="
                                                        $t('capping_monthly')
                                                    "
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_capping_monthly'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t('requires_a_number')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('capping_end_date')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_for_shipments_on_selected_date'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_end_date
                                                            .$model
                                                    "
                                                    size="sm"
                                                    :label="
                                                        $t('capping_end_date')
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: 'Yes',
                                                        },
                                                        {
                                                            value: false,
                                                            label: 'No',
                                                        },
                                                    ]"
                                                    :inline="true"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                />
                                                <DatePicker
                                                    v-model="
                                                        $v.forms.general
                                                            .end_date.$model
                                                    "
                                                    :min-date="new Date()"
                                                    :model-config="
                                                        vCalendar.modelConfig
                                                    "
                                                >
                                                    <template
                                                        v-slot="{
                                                            inputValue,
                                                            inputEvents,
                                                        }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormValid(
                                                                    {
                                                                        formName:
                                                                            'general',
                                                                        fieldName:
                                                                            'end_date',
                                                                    }
                                                                )
                                                            "
                                                            :value="inputValue"
                                                            v-on="inputEvents"
                                                            :label="
                                                                $t('end_date')
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_date'
                                                                )
                                                            "
                                                            :disabled="
                                                                !forms.general
                                                                    .capping_end_date
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'date_is_required'
                                                                )
                                                            "
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                </DatePicker>
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('capping_start_time')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_for_shipments_on_selected_date'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_start_time
                                                            .$model
                                                    "
                                                    size="sm"
                                                    :label="
                                                        $t('capping_start_time')
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: 'Yes',
                                                        },
                                                        {
                                                            value: false,
                                                            label: 'No',
                                                        },
                                                    ]"
                                                    :inline="true"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                />
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'start_time',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .start_time.$model
                                                    "
                                                    type="time"
                                                    :label="$t('start_time')"
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_start_time'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'requires_a_start_time'
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('capping_end_time')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_for_shipments_on_selected_date'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_end_time
                                                            .$model
                                                    "
                                                    size="sm"
                                                    :label="
                                                        $t('capping_end_time')
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: 'Yes',
                                                        },
                                                        {
                                                            value: false,
                                                            label: 'No',
                                                        },
                                                    ]"
                                                    :inline="true"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                />
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'end_time',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .end_time.$model
                                                    "
                                                    type="time"
                                                    :label="$t('end_time')"
                                                    :placeholder="
                                                        $t('enter_the_end_time')
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'requires_a_end_time'
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('capping_weekdays')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_prevents_deliveries_on_certain_working_days'
                                                        )
                                                    "
                                                />

                                                <SelectTags
                                                    :placeholder="
                                                        $t('select_weekdays')
                                                    "
                                                    size="sm"
                                                    :value.sync="
                                                        cappingWeekDays
                                                    "
                                                    :options="
                                                        $options.options
                                                            .weekDays
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :label="
                                                        $t('capping_weekdays')
                                                    "
                                                />
                                            </FormSection>

                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t(
                                                            'capping_email_duplication'
                                                        )
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_is_used_not_to_send_duplicate_emails_in_the_selected_interval'
                                                        )
                                                    "
                                                />

                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_email_duplication
                                                            .$model
                                                    "
                                                    size="sm"
                                                    :label="
                                                        $t(
                                                            'capping_email_duplication'
                                                        )
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: $t('yes'),
                                                        },
                                                        {
                                                            value: false,
                                                            label: $t('no'),
                                                        },
                                                    ]"
                                                    :inline="true"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                />
                                                <CSelect
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'interval_capping_email_duplication',
                                                        })
                                                    "
                                                    :disabled="
                                                        !forms.general
                                                            .capping_email_duplication
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .interval_capping_email_duplication
                                                            .$model
                                                    "
                                                    :options="
                                                        $options.options
                                                            .intervals
                                                    "
                                                    :label="
                                                        $t(
                                                            'capping_email_duplication_interval'
                                                        )
                                                    "
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t(
                                                            'capping_phone_duplication'
                                                        )
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'this_capping_is_used_not_to_send_duplicate_phones_in_the_selected_interval'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_phone_duplication
                                                            .$model
                                                    "
                                                    :label="
                                                        $t(
                                                            'capping_phone_duplication_active'
                                                        )
                                                    "
                                                    size="sm"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: $t('yes'),
                                                        },
                                                        {
                                                            value: false,
                                                            label: $t('no'),
                                                        },
                                                    ]"
                                                    :inline="true"
                                                />
                                                <CSelect
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'interval_capping_phone_duplication',
                                                        })
                                                    "
                                                    :disabled="
                                                        !forms.general
                                                            .capping_phone_duplication
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .interval_capping_phone_duplication
                                                            .$model
                                                    "
                                                    :options="
                                                        $options.options
                                                            .intervals
                                                    "
                                                    :label="
                                                        $t(
                                                            'capping_phone_duplication_interval'
                                                        ) + ':'
                                                    "
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t(
                                                            'Capping phone duplication between campaigns'
                                                        )
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'This limit is used to avoid sending duplicate phones between the campaign list.'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_phone_duplication_between_campaigns
                                                            .$model
                                                    "
                                                    :label="
                                                        $t('Capping active') +
                                                        ':'
                                                    "
                                                    size="sm"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: $t('yes'),
                                                        },
                                                        {
                                                            value: false,
                                                            label: $t('no'),
                                                        },
                                                    ]"
                                                    :inline="true"
                                                />
                                                <CSelect
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName: 'general',
                                                            fieldName:
                                                                'interval_capping_phone_duplication_between_campaigns',
                                                        })
                                                    "
                                                    :disabled="
                                                        !forms.general
                                                            .capping_phone_duplication_between_campaigns
                                                    "
                                                    :value.sync="
                                                        $v.forms.general
                                                            .interval_capping_phone_duplication_between_campaigns
                                                            .$model
                                                    "
                                                    :options="
                                                        $options.options
                                                            .intervals
                                                    "
                                                    :label="
                                                        $t('Capping interval') +
                                                        ':'
                                                    "
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                                <SelectAsync
                                                    typeSelect="SelectTags"
                                                    :label="$t('Campaigns')"
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                    :value.sync="
                                                        campaignListToCappingPhoneDuplicationBetweenCampaignsValue
                                                    "
                                                    :formatOptions="
                                                        parseIntOptionsValue
                                                    "
                                                    :disabled="
                                                        !forms.general
                                                            .capping_phone_duplication_between_campaigns
                                                    "
                                                    optionsValue="id"
                                                    optionsLabel="name"
                                                    endpoint="campaigns.api"
                                                    :fetchConfig="{
                                                        params: {
                                                            query: {
                                                                where: {
                                                                    uuid: {
                                                                        not_equal:
                                                                            this
                                                                                .uuid,
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    }"
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t(
                                                            'Capping by acceptance filters'
                                                        )
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'You can set up acceptance filters to limit the records sent.'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_by_acceptance_filters_active
                                                            .$model
                                                    "
                                                    :label="
                                                        $t('Capping active') +
                                                        ':'
                                                    "
                                                    size="sm"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: $t('yes'),
                                                        },
                                                        {
                                                            value: false,
                                                            label: $t('no'),
                                                        },
                                                    ]"
                                                    :inline="true"
                                                />
                                                <CCTableAcceptanceFilters
                                                    :fields="
                                                        storeGlobalFieldsAdvance
                                                    "
                                                    :filters.sync="
                                                        $v.forms.general
                                                            .capping_by_acceptance_filters_configuration
                                                            .$model
                                                    "
                                                    :conditions="
                                                        $options.options
                                                            .conditions
                                                    "
                                                />
                                            </FormSection>
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t(
                                                            'Capping by client pre validation'
                                                        )
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'You can prevalidate a lead before sending it to the client'
                                                        )
                                                    "
                                                />
                                                <LInputRadioGroup
                                                    :checked.sync="
                                                        $v.forms.general
                                                            .capping_by_client_pre_validation_active
                                                            .$model
                                                    "
                                                    :label="
                                                        $t('Capping active') +
                                                        ':'
                                                    "
                                                    size="sm"
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :options="[
                                                        {
                                                            value: true,
                                                            label: $t('yes'),
                                                        },
                                                        {
                                                            value: false,
                                                            label: $t('no'),
                                                        },
                                                    ]"
                                                    :inline="true"
                                                />
                                                <label
                                                    for="client-pre-validation-configuration"
                                                    class="col-form-label col-form-label-sm"
                                                >
                                                    {{
                                                        $t(
                                                            "Capping configuration:"
                                                        )
                                                    }}
                                                </label>
                                                <CCCappingByClientPreValidation
                                                    :value.sync="
                                                        $v.forms.general
                                                            .capping_by_client_pre_validation_configuration
                                                            .$model"
                                                    :encode="true"
                                                />
                                            </FormSection>
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave
                                    @click="submitForm($event, 'general')"
                                    :disabled="forms.general._loading"
                                />
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import SelectCountry from "£lement/SelectCountry";
import SelectAsync from "£lement/SelectAsync";
import LInputRadioGroup from "~/components/LInputRadioGroup";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import SelectTags from "£lement/SelectTags";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";
import FormSectionDescription from "~/components/FormSectionDescription.vue";
import FormSection from "~/components/FormSection.vue";
import CCTableAcceptanceFilters from "~/components/CCTableAcceptanceFilters.vue";
import CCCappingByClientPreValidation from "./Components/CCCappingByClientPreValidation.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import formMixin from "~/mixins/form.js";
import tableMixin from "~/mixins/table.js";
import { validationMixin } from "vuelidate";

/** Others */
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
    cilSettings,
} from "@coreui/icons";
import weekDaysOptions from "./config/options/week_days.js";
import IntervalsOptions from "./config/options/intervals.js";
import ConditionsAllowed from "~/pages/app/config/options/filter_type";

export default {
    name: "ClientsViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, formMixin, tableMixin],
    components: {
        SelectCountry,
        SelectAsync,
        SelectTags,
        Calendar,
        DatePicker,
        LInputRadioGroup,
        ButtonBack,
        ButtonSave,
        FormSectionDescription,
        FormSection,
        CCTableAcceptanceFilters,
        CCCappingByClientPreValidation
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPlus,
        cilTrash,
    },
    options: {
        weekDays: weekDaysOptions,
        intervals: IntervalsOptions,
        conditions: ConditionsAllowed,
    },
    data() {
        return {
            methodApiConfiguratiom: {},
            matchResponseBody: [],
            mappingFields: [],
            fixedFields: [],
            forms: {
                general: {
                    client_model_id: null,
                    name: null,
                    capping: null,
                    capping_interval: null,
                    capping_total: null,
                    capping_daily: null,
                    capping_weekly: null,
                    capping_monthly: null,
                    capping_notification_ok: null,
                    capping_notification_ko: null,
                    capping_week_days: null,
                    capping_end_date: false,
                    end_date: null,
                    capping_start_time: false,
                    start_time: null,
                    capping_end_time: false,
                    end_time: null,
                    sale_price: null,
                    description: null,
                    country_id: null,
                    debug_mode: 1,
                    advance_validation: false,
                    capping_email_duplication: false,
                    capping_phone_duplication: false,
                    interval_capping_email_duplication: null,
                    interval_capping_phone_duplication: null,
                    capping_phone_duplication_between_campaigns: false,
                    capping_by_acceptance_filters_active: false,
                    capping_by_acceptance_filters_configuration: "[]",
                    interval_capping_phone_duplication_between_campaigns: null,
                    campaign_list_to_capping_phone_duplication_between_campaigns:
                        null,
                    capping_by_client_pre_validation_active: false,
                    capping_by_client_pre_validation_configuration: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
            tables: {
                databases: {
                    items: [],
                    fields: [
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "options",
                            label: "options",
                            _style: "width:10%",
                            _classes: "text-center",
                            sorter: false,
                            filter: false,
                        },
                    ],
                    order: "desc",
                    rows: 5,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                    hover: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: true,
                    allFields: [],
                    itemsPerPageSelect: true,
                    export: null,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    responsive: true,
                    columnFilterValue: {},
                    itemSelected: null,
                },
            },
            vCalendar: {
                modelConfig: {
                    type: "string",
                    mask: "YYYY-MM-DD", // Uses 'iso' if missing
                },
            },
            page: {
                _loading: true,
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },

        cappingWeekDays: {
            get() {
                let weekDays = JSON.parse(this.forms.general.capping_week_days);

                let weekDaysOptions = this.$options.options.weekDays;
                let weekDaysOptionsFiltered = [];

                weekDaysOptions.forEach((weekDay) => {
                    if (
                        weekDays &&
                        weekDays.find((toFind) => toFind == weekDay.value)
                    ) {
                        weekDaysOptionsFiltered.push(weekDay);
                    }
                });
                return weekDaysOptionsFiltered;
            },
            set(value) {
                let weekDays = [];
                value.forEach(function (weekDay) {
                    weekDays.push(weekDay.value);
                });
                this.forms.general.capping_week_days = JSON.stringify(weekDays);
            },
        },

        campaignListToCappingPhoneDuplicationBetweenCampaignsValue: {
            get() {
                const parse = JSON.parse(
                    this.forms.general
                        .campaign_list_to_capping_phone_duplication_between_campaigns
                );
                return parse;
            },
            set(value) {
                this.forms.general.campaign_list_to_capping_phone_duplication_between_campaigns =
                    JSON.stringify(value);
            },
        },
    },
    watch: {},
    validations: {
        forms: {
            general: {
                client_model_id: {
                    required,
                },
                name: {
                    required,
                },
                capping: {
                    numeric,
                },
                capping_interval: {
                    required,
                },
                capping_total: {
                    numeric,
                },
                capping_daily: {
                    numeric,
                },
                capping_weekly: {
                    numeric,
                },
                capping_monthly: {
                    numeric,
                },
                capping_notification_ok: {
                    // required
                },
                capping_notification_ko: {
                    // required
                },
                capping_end_date: {},
                end_date: {
                    // required
                },
                capping_start_time: {},
                start_time: {
                    // required
                },
                capping_end_time: {},
                end_time: {
                    // required
                },
                sale_price: {},
                description: {
                    // required
                },
                country_id: {
                    required,
                },
                debug_mode: {
                    required,
                },
                advance_validation: {},
                capping_email_duplication: {},
                interval_capping_email_duplication: {
                    required: requiredIf(function (nestedModel) {
                        return nestedModel.capping_email_duplication === true;
                    }),
                },
                capping_phone_duplication: {},
                interval_capping_phone_duplication: {
                    required: requiredIf(function (nestedModel) {
                        return nestedModel.capping_phone_duplication === true;
                    }),
                },
                capping_phone_duplication_between_campaigns: {},
                interval_capping_phone_duplication_between_campaigns: {
                    required: requiredIf(function (nestedModel) {
                        return (
                            nestedModel.capping_phone_duplication_between_campaigns ===
                            true
                        );
                    }),
                },
                campaign_list_to_capping_phone_duplication_between_campaigns:
                    {},
                capping_by_acceptance_filters_active: {},
                capping_by_acceptance_filters_configuration: {
                    required: requiredIf(function (nestedModel) {
                        return (
                            nestedModel.capping_by_acceptance_filters_active ===
                            true
                        );
                    }),
                },

                capping_by_client_pre_validation_active: {},
                capping_by_client_pre_validation_configuration: {
                    required: requiredIf(function (nestedModel) {
                        return (
                            nestedModel.capping_by_client_pre_validation_active ===
                            true
                        );
                    }),
                },
            },
        },
    },
    methods: {
        parseIntOptionsValue(data) {
            const result = data._items.map((item) => {
                return {
                    value: parseInt(item.id),
                    label: item.name,
                    name: item.name,
                };
            });

            return result;
        },
        async submitForm(e, formName) {
            if (e) e.preventDefault();
            if (this.uuid) {
                await this.sendForm({
                    formName,
                    url: `/campaigns.api/${this.uuid}/update`,
                    method: "PUT",
                });
            } else {
                await this.sendForm({
                    formName,
                    url: "/campaigns.api/create",
                });
            }
            this.$router.go(-1);
        },
        async updateFormGeneral() {
            await this.updateForm({
                formName: "general",
                url: `/campaigns.api/${this.uuid}`,
                url_param: this.uuid,
            });
            this.updatePageLoading(false);
        },

        async onChangeSelectDBs(database_id) {
            let url = `/db/${database_id}/client/rel/${this.uuid}`;

            await this.sendData({
                url,
                method: "POST",
            });

            await this.updateTableDatabases();
        },

        async deleteDatabase(db) {
            try {
                await this.deleteData({
                    url: `/campaigns.api/${this.uuid}/databases/${db.uuid}`,
                });
                await this.updateTableDatabases();
            } catch (error) {
                return;
            }
        },

        async updateTableDatabases() {
            await this.updateTable({
                tableName: "databases",
                url: `/campaigns.api/${this.uuid}/databases`,
            });
        },
    },
    async mounted() {
        if (this.uuid) {
            await this.updateFormGeneral();
            await this.updateTableDatabases();
        }

        this.updatePageLoading(false);
    },
    created() {
        this.loadFields();
        this.loadFieldsAdvance();
    },
};
</script>

<style scoped lang="scss"></style>
